module.exports = __webpack_public_path__ + "static/media/S (124).6031d65e.jpg";